import { _ as _extends } from './_rollupPluginBabelHelpers-c7687d88.js';
import React__default, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import FeedbackTooltip from './FeedbackTooltip.js';
import { c as commonPropTypes } from './commonPropTypes-8c108b82.js';
import { F as FormIntent, a as IconNames } from './types-6e7da022.js';
import { s as styles, I as InputIcon } from './InputIcon-0309541b.js';
import 'prop-types';
import './Tooltip-6986252d.js';
import '@tippy.js/react';
import './error-6281581e.js';
import './IconRouter.js';
import './add-4a4fe5c2.js';
import './filter-a4af09e9.js';
import './loading-6cabb422.js';
import './magnifying-glass-3c43cfbb.js';
import './search-42d3c9cc.js';
import './down-f9e6ad7e.js';
import './close-thin-a9749b58.js';
import './tick-filled-fbbd6819.js';
import './helpers-f6b58b19.js';
import '@motorway/motorway-tools/typeHelpers';

const PRIMITIVE_TYPES = ['text', 'email', 'search', 'number', 'password', 'tel', 'date'];
const Input = ({
  className,
  feedbackTooltip = {},
  innerClassName,
  inputFocused = false,
  inputProps,
  intent = null,
  label = null,
  labelProps = {},
  large = false,
  leftIconName = '',
  money = false,
  noIcon = false,
  onClickIcon = () => {},
  optionalLabel = null,
  renderInput = null,
  rightIconName = null,
  vrm = false
}) => {
  const [wrapperRef, setWrapperRef] = useState(null);
  const inputRef = useRef();
  const {
    input: {
      disabled,
      type
    }
  } = inputProps;
  const rightIcon = intent === FormIntent.SUCCESS ? IconNames.VALIDATE_SUCCESS : rightIconName;
  const typeForInput = PRIMITIVE_TYPES.includes(type) ? type : 'text';
  const commonProps = {
    ...inputProps.input,
    className: styles.input,
    id: inputProps.id,
    type: typeForInput
  };
  if (!inputProps.id) {
    console.warn(`Input element with the label "${label}" needs an ID attribute to associate label with the input`);
  }
  useEffect(() => {
    if (inputFocused) {
      inputRef?.current?.focus?.();
    } else {
      inputRef?.current?.blur?.();
    }
  }, [inputFocused]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx(styles.input, styles[`input-${rightIcon || 'text'}`], styles[`input-intent-${intent}`], {
      [styles['input-icon-left']]: leftIconName,
      [styles['input-large']]: large,
      [styles['input-money']]: money,
      [styles['input-no-icon']]: noIcon,
      [styles['input-vrm']]: vrm,
      [styles['input-disabled']]: disabled
    }, className)
  }, label && /*#__PURE__*/React__default.createElement("div", {
    className: styles.labelContainer
  }, /*#__PURE__*/React__default.createElement("label", _extends({
    htmlFor: inputProps.id
  }, labelProps), label), optionalLabel), /*#__PURE__*/React__default.createElement(FeedbackTooltip, {
    appendTo: feedbackTooltip.appendTo || wrapperRef,
    content: feedbackTooltip.content,
    fillWidth: feedbackTooltip.fillWidth,
    intent: intent,
    interactive: feedbackTooltip.interactive,
    isTabletMobile: feedbackTooltip.isTabletMobile,
    placement: feedbackTooltip.placement,
    placementFlipped: feedbackTooltip.placementFlipped,
    theme: feedbackTooltip.theme,
    tooltipClassName: feedbackTooltip.className,
    tooltipIcon: feedbackTooltip.tooltipIcon,
    zIndex: feedbackTooltip.zIndex
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: setWrapperRef,
    className: cx(styles.control, innerClassName)
  }, leftIconName && /*#__PURE__*/React__default.createElement(InputIcon, {
    className: styles.leftIcon,
    icon: leftIconName,
    inputFocused: inputFocused
  }), renderInput ? renderInput(commonProps) : /*#__PURE__*/React__default.createElement("input", _extends({}, commonProps, {
    ref: inputRef
  })), !noIcon && /*#__PURE__*/React__default.createElement(InputIcon, {
    className: styles.rightIcon,
    icon: rightIcon,
    inputFocused: inputFocused,
    onClick: onClickIcon
  }))));
};
Input.propTypes = {
  ...commonPropTypes.inputConfig
};

export { Input as default };
